import { render, staticRenderFns } from "./AsideDashboard.vue?vue&type=template&id=59156b3a&"
import script from "./AsideDashboard.vue?vue&type=script&lang=js&"
export * from "./AsideDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports